import React, { useEffect, useState } from "react";
import { Heading, Loader, Popup, ToastErrorTile } from "uikit/components";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useGenerateSchoolSummary } from "hooks/schoolSummary";
import SchoolSummaryView from "components/schoolSummary/SchoolSummaryView/SchoolSummaryView";
import { Helmet } from "react-helmet-async";

export default function SchoolSummaryPage() {
    const { schoolId } = useParams();

    const [result, setResult] = useState(null);

    const { build: generateSchoolSummary, isLoading: isGeneratingSchoolSummary } =
        useGenerateSchoolSummary({
            onSuccess: (report) => setResult(report),
            onError: (error) => toast.error(<ToastErrorTile error={error} />),
        });

    useEffect(() => {
        generateSchoolSummary(schoolId);
    }, [generateSchoolSummary, schoolId]);

    if (isGeneratingSchoolSummary) {
        return (
            <Popup blockClickOnOverlay appearance="adaptive">
                <Loader
                    position={"margin-auto"}
                    text={"Подождите. Данные загружаются."}
                    testName="loader-text"
                />
            </Popup>
        );
    }

    if (result != null) {
        return (
            <>
                <Helmet>
                    <meta
                        name="apple-mobile-web-app-title"
                        content={`Атлас спортивной подготовки: ${result.schoolName}`}
                    />
                    <meta
                        name="application-name"
                        content={`Атлас спортивной подготовки: ${result.schoolName}`}
                    />
                    <title>Атлас спортивной подготовки: {result.schoolName}</title>
                </Helmet>
                <Heading size={"h1"} name="school-summary-title">
                    Атлас спортивной подготовки: {result.schoolName}
                </Heading>
                <SchoolSummaryView
                    currentDate={result.currentDate}
                    previousWeekStartDate={result.previousWeekStartDate}
                    previousWeekEndDate={result.previousWeekEndDate}
                    currentWeekStartDate={result.currentWeekStartDate}
                    currentWeekEndDate={result.currentWeekEndDate}
                    nextWeekStartDate={result.nextWeekStartDate}
                    nextWeekEndDate={result.nextWeekEndDate}
                    schoolSummaryData={result.summary}
                    schoolId={result.schoolId}
                />
            </>
        );
    }
}
